/** Production canonical host (Model A: / → /en). */
export const SITE_ORIGIN_CANONICAL = 'https://isuma.org'

const TRACKING_PARAM_PREFIXES = ['utm_']
const TRACKING_PARAMS = new Set([
  'gclid',
  'fbclid',
  'yclid',
  'ymclid',
  '_ga',
  'ref',
  'source',
  'si',
])

/**
 * @param {string} search - location.search including leading ?
 * @returns {string} query string without tracking params ("" or "?a=b")
 */
export function stripTrackingFromSearch(search) {
  if (!search || search === '?') return ''
  const q = search.startsWith('?') ? search.slice(1) : search
  const params = new URLSearchParams(q)
  for (const key of [...params.keys()]) {
    const lower = key.toLowerCase()
    if (TRACKING_PARAMS.has(lower)) params.delete(key)
    else if (TRACKING_PARAM_PREFIXES.some((p) => lower.startsWith(p))) params.delete(key)
  }
  const out = params.toString()
  return out ? `?${out}` : ''
}

/**
 * Deterministic public URL for canonical / og:url (no hash, no tracking query).
 * @param {string} origin
 * @param {string} pathname
 * @param {string} search location.search
 */
export function buildSeoUrl(origin, pathname, search) {
  const clean = stripTrackingFromSearch(search || '')
  return `${origin}${pathname}${clean}`
}

/**
 * Absolute URL for static assets (og:image) — path must start with /
 */
export function absoluteAssetUrl(origin, path) {
  if (!path) return origin
  if (path.startsWith('http://') || path.startsWith('https://')) return path
  return `${origin}${path.startsWith('/') ? path : `/${path}`}`
}

/** Два уровня: главная → страница (pathSegment без ведущего слэша). */
export function seoBreadcrumbPair(homeLabel, pageLabel, pathSegment) {
  return [
    { name: homeLabel, pathSuffix: '' },
    { name: pageLabel, pathSuffix: pathSegment },
  ]
}

/** Три уровня: главная → раздел → лист. leafSegment вида `martial-arts/kubo`. */
export function seoBreadcrumbTriple(homeLabel, midLabel, midSegment, leafLabel, leafSegment) {
  return [
    { name: homeLabel, pathSuffix: '' },
    { name: midLabel, pathSuffix: midSegment },
    { name: leafLabel, pathSuffix: leafSegment },
  ]
}
